import React from 'react';
import Reload from 'app/components/svgs/Reload';
import Button, { IProps as ButtonProps, MODAL } from 'app/components/forms/Button';
import { useCss } from 'app/utils/css';

interface IProps extends Omit<ButtonProps, 'variant'> {
  children: React.ReactNode;
}

export default function ReloadButton({ children, ...rest }: IProps) {
  const css = useCss();

  return (
    <Button variant={MODAL} {...rest}>
      <div className={css('buttonContent', {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      })}
      >
        <span className={css('buttonText', { marginRight: '8px' })}>
          {children}
        </span>

        <Reload size="1em" />
      </div>
    </Button>
  );
}
